/* ===================== i18n runtime (bilingual KO/EN) ===================== */
var __T = Object.assign({}, __T_P1, __T_P2, __T_P3, __T_P4, __T_P5, __T_P6);
var __EXCL = new Set(["기초", "조합", "자극이 오면 덧바르지 말아주세요", "각질제거와 필링 횟수를 줄여주세요", "기능성 성분 가짓수를 줄여주세요", "저녁 스킨케어 단계를 줄여주세요", "뜨거운 물 세안은 피해주세요", "겹치는 단계를 하나로 합쳐주세요", "과소", "적정", "과부하"]);
function __detectLoc(){
  try{ var sp=new URL(location.href).searchParams; var q=sp.get("lang"); if(q==="en"||q==="ko") return q; }catch(e){}
  try{ if(/(^|\/)en(\/|$)/.test(location.pathname)) return "en"; }catch(e){}
  try{ if(/^\/ko(\/|$)/.test(location.pathname)) return "ko"; }catch(e){}
  return "en"; /* 경로 규칙과 일치(/ko/*=KO, 루트=EN) — 첫 렌더부터 확정, 지연 리로드 플래시 제거 */
}
var __LOC = __detectLoc();
try{ document.documentElement && document.documentElement.setAttribute("lang", __LOC); }catch(e){}
function __L(v){ return (__LOC==="en" && typeof v==="string" && !__EXCL.has(v) && __T[v]!=null) ? __T[v] : v; }
function __LD(v){ return (__LOC==="en" && typeof v==="string" && __T[v]!=null) ? __T[v] : v; }
function __trDeep(o){
  if(o==null) return o;
  if(typeof o==="string") return __L(o);
  if(Array.isArray(o)) return o.map(__trDeep);
  if(typeof o==="object"){ var r={}; for(var k in o){ if(Object.prototype.hasOwnProperty.call(o,k)) r[k]=__trDeep(o[k]); } return r; }
  return o;
}
var Q,STATES,READINGS,FRAG,CUT_INFO,SLOTS,PRODUCTS,LIB,TAGNAME,SIGNAL,OWN,CUT_EMPTY,CUT_TEASER,SLOT_LEAD_BASE,SLOT_DISCLOSE,SLOT_EMPTY_P4F;
function __applyLocale(){
  var en = (__LOC==="en");
  Q=en?__trDeep(Q_KO):Q_KO; STATES=en?__trDeep(STATES_KO):STATES_KO;
  READINGS=en?__trDeep(READINGS_KO):READINGS_KO; FRAG=en?__trDeep(FRAG_KO):FRAG_KO;
  CUT_INFO=en?__trDeep(CUT_INFO_KO):CUT_INFO_KO; SLOTS=en?__trDeep(SLOTS_KO):SLOTS_KO;
  PRODUCTS=en?__trDeep(PRODUCTS_KO):PRODUCTS_KO; LIB=en?__trDeep(LIB_KO):LIB_KO;
  TAGNAME=en?__trDeep(TAGNAME_KO):TAGNAME_KO; SIGNAL=en?__trDeep(SIGNAL_KO):SIGNAL_KO;
  OWN=en?__trDeep(OWN_KO):OWN_KO;
  CUT_EMPTY=en?__L(CUT_EMPTY_KO):CUT_EMPTY_KO; CUT_TEASER=en?__L(CUT_TEASER_KO):CUT_TEASER_KO;
  SLOT_LEAD_BASE=en?__L(SLOT_LEAD_BASE_KO):SLOT_LEAD_BASE_KO; SLOT_DISCLOSE=en?__L(SLOT_DISCLOSE_KO):SLOT_DISCLOSE_KO;
  SLOT_EMPTY_P4F=en?__L(SLOT_EMPTY_P4F_KO):SLOT_EMPTY_P4F_KO;
}
__applyLocale();
/* ===================== static HTML i18n + ko/en toggle ===================== */
var __STATIC = [
 ["#gateLead .formula-copy", "Rituals to drop, rituals to start today, product picks made for you, and notes for what’s on your mind right now. Leave your email to see them."],
 ["#intro h1", "We’ll read your skin,<br>as it is today"],
 ["#intro .sub", "Not the trends — <b>what your skin needs right now.</b><br>A 60-second reading."],
 ["#intro .btn-bar", "Read my skin today"],
 ["#intro .disclaimer", "This reading isn’t medical care — it’s a tool to guide your ritual.<br>If a concern runs deep or a condition is suspected, please see a dermatologist."],
 ["#backBtn", "← Back"],
 ["#cutSec .shead", "<span class=\"sn\">01</span>Habits to drop<span class=\"nsh-chip stop\">Pause for now</span>"],
 ["#cutLead", "No need to do it all at once. Just one today is plenty."],
 ["#slotSec .shead", "<span class=\"sn\">02</span>Rituals to start today<span class=\"nsh-chip go\">Add these</span>"],
 ["#sigSec .shead", "A sign it’s getting better"],
 ["#noteSec .shead", "<span class=\"sn\">04</span>Stories for what’s on your mind"],
 ["#sharedCta .formula-h", "How about your skin?"],
 ["#sharedCta .formula-copy", "Skin isn’t a type — it’s today’s state. Answer a few questions and we’ll show you what to stop and what to start for your skin right now."],
 ["#sharedCta .btn-bar", "Check my skin state"],
 ["#sharedCta .meta", "13 questions · 60 seconds"],
 ["#wlBox > .formula-h", "A ritual guide for your concern"],
 ["#wlBox > .formula-copy", "Tailored to your state and concern, we’ll put it together and send it to your inbox."],
 ["#waitForm button[type=submit]", "Open my full reading →"],
 ["#emailErr", "Please check your email address."],
 ["#wlBox .consent", "By agreeing to the <a href=\"/policies/privacy-policy\">Privacy Policy</a>, you’ll get the ritual guide by email. Unsubscribe anytime."],
 ["#shareWrap .btn-ghost", "Share"],
 ["#shareWrap .link", "Start over"],
 ["#veilText", "Bringing your answers into one state."],
 [".cta-float-q", "How about your skin?"],
 [".cta-float-btn", "Check my skin state"]
];
var __koSnap = null;
function __snapKO(){
  if(__koSnap) return; __koSnap={};
  for(var i=0;i<__STATIC.length;i++){ try{ var el=document.querySelector(__STATIC[i][0]); if(el) __koSnap[i]=el.innerHTML; }catch(e){} }
  try{ var em=document.getElementById("email"); if(em) __koSnap["_ph"]=em.getAttribute("placeholder")||""; }catch(e){}
}
function __applyStatic(loc){
  __snapKO();
  for(var i=0;i<__STATIC.length;i++){
    try{ var el=document.querySelector(__STATIC[i][0]); if(!el) continue;
      el.innerHTML = (loc==="en") ? __STATIC[i][1] : (__koSnap[i]!=null?__koSnap[i]:el.innerHTML);
    }catch(e){}
  }
  try{ var em=document.getElementById("email"); if(em) em.setAttribute("placeholder", loc==="en" ? "Email address" : (__koSnap["_ph"]||"이메일 주소")); }catch(e){}
  try{ var ls=document.getElementById("locSwitch"); if(ls){ var bs=ls.querySelectorAll("button"); for(var j=0;j<bs.length;j++){ bs[j].classList.toggle("on", bs[j].getAttribute("data-l")===loc); } } }catch(e){}
}
function __setLoc(loc){
  try{ localStorage.setItem("nshLoc", loc); }catch(e){}
  try{ var u=new URL(location.href); u.searchParams.set("lang", loc); location.href=u.toString(); }catch(e){ location.reload(); }
}
function __initLoc(){
  __applyStatic(__LOC);
  try{ var ls=document.getElementById("locSwitch"); if(ls){ var bs=ls.querySelectorAll("button"); for(var j=0;j<bs.length;j++){ (function(b){ b.addEventListener("click", function(){ __setLoc(b.getAttribute("data-l")); }); })(bs[j]); } } }catch(e){}
}
try{ if(document.readyState!=="loading") __initLoc(); else document.addEventListener("DOMContentLoaded", __initLoc); }catch(e){}

/* ---------- 상태 ---------- */
let idx=0, answers=[], acc, locked=false;
function resetAcc(){ acc={oil:0,dry:0,bar:0,load:0,flags:{},concern:""}; }
resetAcc();

function start(){ idx=0; answers=[]; resetAcc(); locked=false; if(typeof Image!=="undefined"){["c1","c2","c3","r9"].forEach(k=>{const i=new Image(); i.src=imgUrl(MEDIA_IMGS[k]);});} show("quiz"); render(); }
function show(id){ ["intro","quiz","result"].forEach(s=>{
  const el=document.getElementById(s); el.classList.toggle("hidden",s!==id);
  if(s===id){ el.classList.remove('rise'); void el.offsetWidth; el.classList.add('rise'); }
});
  document.body.classList.toggle("on-result", id==="result");
  layoutSheet(); }
/* 모바일 시트: 배너=고정 배경. 인트로=콘텐츠 다 보이게 하고 잔여 전부 배너.
   퀴즈·결과=마진 46svh를 두고 24svh만큼 스크롤해 두기 → 평소 22svh 스트립, 아래로 당기면 배너가 리빌됨 */
function layoutSheet(){
  const panel = (typeof document.querySelector==="function") ? document.querySelector(".panel") : null;
  if(!panel || !panel.style) return;
  const mq = (typeof window!=="undefined" && window.matchMedia) ? window.matchMedia("(max-width:880px)").matches : false;
  if(!mq){ panel.style.marginTop=""; return; }
  const vh = window.innerHeight||800;
  const introEl = document.getElementById("intro");
  const onIntro = !!(introEl && introEl.classList && !introEl.classList.contains("hidden"));
  panel.style.marginTop="0px";
  const h = panel.offsetHeight||0;
  if(onIntro){ panel.style.marginTop = Math.max(Math.round(vh*0.24), vh-h) + "px"; void panel.offsetHeight; window.scrollTo(0,0); }
  else { panel.style.marginTop = Math.round(vh*0.46) + "px"; void panel.offsetHeight; window.scrollTo(0, Math.round(vh*0.24)); }
}
if(typeof window!=="undefined" && window.addEventListener){
  let __lw = window.innerWidth;
  window.addEventListener("resize", ()=>{ if(Math.abs(window.innerWidth-__lw)>1){ __lw=window.innerWidth; layoutSheet(); } });
}
layoutSheet();

function render(){
  locked=false;
  setMedia(chapterFor(idx));
  const q=Q[idx];
  const pad=n=>String(n).padStart(2,'0');
  document.getElementById("count").textContent=pad(idx+1)+" / "+pad(Q.length);
  document.getElementById("fill").style.width=((idx)/Q.length*100)+"%";
  document.getElementById("qText").textContent=q.t;
  document.getElementById("backBtn").style.visibility= idx===0 ? "hidden":"visible";
  const wrap=document.getElementById("opts"); wrap.innerHTML="";
  q.o.forEach((o,i)=>{
    const b=document.createElement("button");
    b.className="opt"; b.type="button";
    b.innerHTML='<span class="k">'+(i+1)+'</span><span class="ot">'+o.t+'</span>';
    b.onclick=()=>pick(i);
    wrap.appendChild(b);
  });
  const c=document.getElementById("qcard");
  c.classList.remove('rise'); void c.offsetWidth; c.classList.add('rise');
  if(typeof window!=="undefined" && window.matchMedia && window.matchMedia("(max-width:880px)").matches){ void document.body.offsetHeight; window.scrollTo(0, Math.round((window.innerHeight||800)*0.24)); }
}
function pick(i){
  if(locked) return; locked=true;
  const btns=[...document.querySelectorAll('#opts .opt')];
  btns.forEach((b,j)=>{ b.disabled=true; if(j===i) b.classList.add('sel'); });
  setTimeout(()=>commit(i), 200);
}
function commit(i){
  answers[idx]=i;
  const o=Q[idx].o[i];
  Object.entries(o.s||{}).forEach(([k,v])=>acc[k]+=v);
  if(o.flag) acc.flags[o.flag]=true;
  if(o.concern!==undefined) acc.concern=o.concern;
  if(idx<Q.length-1){ idx++; render(); } else finish();
}
function back(){
  if(idx===0) return;
  idx--;
  resetAcc();
  for(let j=0;j<idx;j++){ const o=Q[j].o[answers[j]]; Object.entries(o.s||{}).forEach(([k,v])=>acc[k]+=v); if(o.flag)acc.flags[o.flag]=true; if(o.concern!==undefined)acc.concern=o.concern; }
  render();
}

document.addEventListener('keydown',(e)=>{
  const on=id=>!document.getElementById(id).classList.contains('hidden');
  if(on('intro') && e.key==='Enter'){ start(); return; }
  if(!on('quiz')) return;
  if(e.key==='Backspace'){ e.preventDefault(); back(); return; }
  const n=parseInt(e.key,10);
  if(!isNaN(n) && n>=1 && n<=Q[idx].o.length){ pick(n-1); }
});

/* ---------- 스코어링 (로직 v1, 무변경) ---------- */
function classify(){
  const oilHigh = acc.oil >= 4;
  const waterLow = acc.dry >= 4;
  const barrierCare = acc.bar >= 3;
  let load = acc.load<=1 ? "과소" : (acc.load<=3 ? "적정" : "과부하");
  if(acc.flags.more && load==="적정" && acc.load===3) load="과부하";
  let P = waterLow ? (oilHigh?"P2":"P1") : (oilHigh?"P3":"P4");
  return {P, care:barrierCare, load, oilHigh, waterLow, barScore:acc.bar, loadScore:acc.load};
}

/* ---------- 리딩 조립 (슬롯 해석) ---------- */
function mdBold(t){ return t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/\*\*(.+?)\*\*/g,"<strong>$1</strong>"); }
function barrierScenes(){ /* Q4=answers[3], Q5=answers[4], Q6=answers[5] · ⓐ=0 · 우선순위 q6>q4>q5 */
  const out=[];
  if(answers[5]===0) out.push("q6");
  if(answers[3]===0) out.push("q4");
  if(answers[4]===0) out.push("q5");
  return out;
}
function s1Echo(r){
  let t=FRAG.s1[answers[0]]||FRAG.s1[0];
  if(answers[0]===3 && r.P==="P1") t+=FRAG.s1aux; /* Q1ⓓ인데 건조 판정 */
  return t;
}
function composeReading(r){
  const R=READINGS[r.P][r.care];
  const paras=R.p.slice();
  const scenes=barrierScenes();
  if(r.care && scenes.length){            /* S2 — 돌봄 + 장면 (발화 시 S5 전체 킬) */
    let s2=FRAG.s2[scenes[0]];
    if(scenes.length>1) s2+=" "+FRAG.s2.multi;
    paras[0]+=" "+s2;
  } else if(r.care){                       /* 돌봄인데 ⓐ 장면 없음 → S5 장벽 강도 */
    if(acc.bar>=5) paras[0]+=" "+FRAG.s5.barHigh;
    else paras[0]+=" "+FRAG.s5.barLow;
  } else {                                 /* 안정 → 이른 신호 or 유수분 경계 */
    if(scenes.length && acc.bar>=1) paras[0]+=" "+FRAG.s2.early(scenes[0]);
    else if(Math.abs(acc.oil-4)<=1 || Math.abs(acc.dry-4)<=1) paras[0]+=" "+FRAG.s5.axis;
  }
  /* S3 — 부하 서사 (Q10ⓐ > Q8ⓐ > Q7ⓐ > Q9ⓐ) */
  const f=acc.flags;
  const s3 = f.more ? FRAG.s3.more
    : r.load==="과부하" ? (f.active?FRAG.s3.active : f.step?FRAG.s3.step : FRAG.s3.exfol)
    : r.load==="과소" ? FRAG.s3.low : FRAG.s3.ok;
  paras.push(s3);
  return {paras, heart:R.heart};
}

